import { Box, SystemText } from '@salesperformanceint/e4shared';
import { e4Format, e4Formats } from 'helpers/dates';
import React from 'react';
import { withRouter } from 'react-router-dom';

export const ObjectiveCard = ({ history, text, objective, profileId }) => {
    let className = 'success';
    let statusStub = 'OnTime';
    let icon = 'calendar';
    let logo = '';
    let statusIcon = '';
    let datePrefixStub = 'Completed';
    let dateClass = '';
    let dateField = null;
    const loaded = React.useRef(null);

    const resizeHandler = () => {
        loaded.current && DomHelpers.truncateText('ellipse', loaded.current, 0);
    };

    React.useEffect(() => {
        resizeHandler();
    }, [loaded.current]);

    let now = new Date().toISOString();

    if (objective.date2) {
        if (objective.date2 > objective.date1) {
            // done late
            className = 'danger';
            statusStub = 'late';
            statusIcon = 'warning';
            datePrefixStub = 'completed';
            dateField = objective.date2;
        } else {
            // done on time
            className = 'success';
            statusStub = 'onTime';
            statusIcon = 'thumbs-up';
            datePrefixStub = 'completed';
            dateField = objective.date2;
        }
    } else {
        if (objective.date1 < now) {
            // not done overdue
            className = 'danger';
            statusStub = 'overdue';
            statusIcon = 'warning';
            datePrefixStub = 'due';
            dateClass = 'text-danger';
            dateField = objective.date1;
        } else {
            // not done
            className = 'warning';
            statusStub = 'outstanding';
            statusIcon = '';
            datePrefixStub = 'due';
            dateField = objective.date1;
        }
    }

    switch (objective.extras4) {
        case 'metric':
            icon = 'bullseye';
            break;
        case 'pitchback':
            icon = 'video';
            break;
        case 'lms':
            icon = 'graduation-cap';
            break;
        default:
            icon = 'calendar';
    }

    if (objective.extras7) icon = 'sparkles';

    return (
        <Box
            ref={loaded}
            className={`box-${className} objective-box pointer`}
            onClick={() => history.push(`/objectives/${profileId}/objective/${objective.id}`)}
        >
            <div className="flex flex-center">
                <label className={`label label-${className}`}>
                    {statusIcon && <i className={`fa fa-${statusIcon} mr5`} />}
                    {text.card.statuses[statusStub]}
                </label>
                <div className="flex-grow"></div>
                <i className={`fa fa-${icon} info-icon`} />
            </div>
            <button
                data-testid="btn-explore-objective"
                className="btn btn-link ellipsis"
                onClick={() => history.push(`/objectives/${profileId}/objective/${objective.id}`)}
            >
                {objective.name}
            </button>
            <div className="description ellipse">{objective.summary}</div>
            <div className={`pull-right time mt5 ${dateClass ? dateClass : ''}`}>
                {/* <i className="fa fa-clock mr5" />6 minutes */}
                {datePrefixStub && (
                    <>
                        <span className="mr5">{text.card[datePrefixStub]}</span>
                        {e4Format(dateField, e4Formats.long)}
                    </>
                )}
            </div>
        </Box>
    );
};

export default withRouter(ObjectiveCard);
